import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { TorreListMode } from '../../shared/utils/torre-list-mode';
import './torre-table-ux.css';

interface TorreListModeToggleProps {
    mode: TorreListMode;
    onChange: (mode: TorreListMode) => void;
    testId?: string;
}

/** Alternância explícita entre visão resumida (lista) e planilha operacional. */
const TorreListModeToggle: React.FC<TorreListModeToggleProps> = ({
    mode,
    onChange,
    testId = 'torre-toggle-list-mode',
}) => (
    <Button.Group className="torre-list-mode-toggle" data-testid={testId}>
        <Button
            type="button"
            active={mode === 'compact'}
            color={mode === 'compact' ? 'green' : undefined}
            onClick={() => onChange('compact')}
            title="Colunas essenciais para monitoramento rápido"
        >
            <Icon name="list ul" />
            Lista
        </Button>
        <Button
            type="button"
            active={mode === 'spreadsheet'}
            color={mode === 'spreadsheet' ? 'blue' : undefined}
            onClick={() => onChange('spreadsheet')}
            title="Todas as colunas editáveis (planilha TNE)"
        >
            <Icon name="table" />
            Planilha
        </Button>
    </Button.Group>
);

export default TorreListModeToggle;
